import { createApp } from "vue";
import { createPinia } from "pinia";
import { router } from "./router";
import axios from "./lib/axios";
import App from "./App.vue";
import "./assets/main.css";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const app = createApp(App);
const pinia = createPinia();

// Make axios available globally
app.config.globalProperties.$axios = axios;

const Vuetify = createVuetify({
    components: components,
    directives: directives
});

app.use(router);
app.use(pinia);
app.use(Vuetify);

app.mount("#app");
